
export const routes = {
    root: "/leads",
    auth: {
        login: "/login",
    },
    dashboard: {
        root: "/dashboard",
    },
    products: {
        root: "/products",
        details: "/products/:id",
    },
    quotes: {
        root: "/quotes",
        details: "/quotes/:id",
        checkout: "/quotes/:id/checkout",
    },
    proposal: {
        view: "/proposal/:token",
        /** One-click internal (Swiftlane) signing link — public, token-authenticated. */
        internalSign: "/proposal/internal-sign/:token",
        details: "/proposals/:id",
    },
    workOrder: {
        view: "/work-order/:token",
    },
    installerCompliancePublic: {
        upload: "/compliance-upload/:token",
        requirements: "/insurance-requirements",
    },
    coiPublic: {
        request: "/coi-request/:token",
    },
    // Public installer testing page: no login, the token is the credential.
    installerAccess: {
        view: "/t/:token",
    },
    proposals: {
        root: "/proposals",
        details: "/proposals/:id",
        /** The document editor (Track C1): full-width v6 canvas, INTERNAL accounts only. */
        edit: "/proposals/:id/edit",
    },
    customers: {
        root: "/customer-accounts",
        details: "/customer-accounts/:id",
        create: "/customer-accounts/create",
    },
    contacts: {
        root: "/contacts",
        create: "/contacts/create",
        details: "/contacts/:id",
    },
    leads: {
        root: "/leads",
        add: "/leads/create",
        details: "/leads/:id",
        convert: "/leads/:id/convert",
        upload: "/leads/upload",
    },
    profile: {
        root: "/profile",
    },
    mcp: {
        /** OAuth consent screen an MCP client sends the browser to. */
        authorize: "/mcp/authorize",
    },
    orders: {
        root: "/orders",
        details: "/orders/:id",
    },
    wallet: {
        root: "/wallet",
    },
    settings: {
        root: "/settings",
        users: {
            root: "/settings/users",
            details: "/settings/users/:id",
            create: "/settings/users/create",
        },
        addresses: {
            root: "/settings/addresses",
            details: "/settings/addresses/:id",
            create: "/settings/addresses/create",
        },
        paymentMethods: {
            root: "/settings/payment-methods",
            linkBankAccount: "/settings/payment-methods/link-bank-account",
        },
        mcp: {
            root: "/settings/mcp",
        },
        taxExemption: {
            root: "/settings/tax-exemption",
        },
    },
    comandCenter: {
        arAging: { root: "/cc/ar-aging", details: "/cc/ar-aging/:id" },
        root: "/cc",
        accounting: {
            root: "/cc/accounting",
        },
        leads: {
            root: "/cc/all-leads",
            details: "/cc/all-leads/:id",
            convert: "/cc/all-leads/:id/convert",
            create: "/cc/all-leads/create",
            upload: "/cc/all-leads/upload",
        },
        orders: {
            root: "/cc/all-orders",
            details: "/cc/all-orders/:id",
        },
        shipping: {
            root: "/cc/shipping",
        },
        products: {
            root: "/cc/all-products",
            create: "/cc/all-products/create",
            edit: "/cc/all-products/:id",
        },
        dealerDiscounts: {
            root: "/cc/dealer-discounts",
            create: "/cc/dealer-discounts/create",
            details: "/cc/dealer-discounts/:id",
        },
        commissionTiers: {
            root: "/cc/commission-tiers",
            create: "/cc/commission-tiers/create",
            details: "/cc/commission-tiers/:id",
        },
        users: {
            root: "/cc/all-users",
            create: "/cc/all-users/create",
            edit: "/cc/all-users/:id",
        },
        accounts: {
            root: "/cc/accounts",
            details: "/cc/accounts/:id",
            create: "/cc/accounts/create",
        },
        accountsNew: {
            root: "/cc/accounts-new",
            details: "/cc/accounts-new/:id",
        },
        quotes: {
            root: "/cc/all-quotes",
            details: "/cc/all-quotes/:id",
            checkout: "/cc/all-quotes/:id/checkout",
        },
        proposals: {
            root: "/cc/proposals",
        },
        projects: {
            root: "/cc/projects",
            create: "/cc/projects/create",
            details: "/cc/projects/:id",
            workOrderDetails: "/cc/projects/:projectId/work-orders/:workOrderId",
        },
        // Local-testing-only entry point for the restructured PM project page (see
        // docs/superpowers/specs/2026-07-31-cc-projects-preview-nav-design.md). Mirrors
        // `projects` above exactly; no `create`/`workOrderDetails` twin needed — this reuses the
        // real ones once a project is opened.
        projectsPreview: {
            root: "/cc/projects-preview",
            details: "/cc/projects-preview/:id",
        },
        calendar: {
            root: "/cc/calendar",
        },
        installerOrgs: {
            root: "/cc/installer-orgs",
            create: "/cc/installer-orgs/create",
            details: "/cc/installer-orgs/:id",
        },
        opportunities: {
            root: "/cc/all-opportunities",
            details: "/cc/all-opportunities/:id",
            create: "/cc/all-opportunities/create",
        },
        contacts: {
            root: "/cc/all-contacts",
            details: "/cc/all-contacts/:id",
        },
        customerAccounts: {
            root: "/cc/all-customer-accounts",
            details: "/cc/all-customer-accounts/:id",
        },
        auditLogs: {
            root: "/cc/audit-logs",
        },
        logs: {
            root: '/cc/audit-logs',
            details: '/cc/audit-logs/:id',
        },
        walletTemplates: {
            root: "/cc/wallet-templates",
            details: "/cc/wallet-templates/:id",
        },
        recurringTransactions: {
            root: "/cc/recurring-transactions",
            details: "/cc/recurring-transactions/:id",
        },
        invoices: {
            root: "/cc/invoices",
        },
        endCustomers: {
            root: "/cc/end-customers",
            details: "/cc/end-customers/:id",
        },
        walletBilling: {
            root: "/cc/wallet-billing",
        },
        currencySettings: {
            root: "/cc/currency-settings",
        },
        bulkFxPricing: {
            root: "/cc/bulk-fx-pricing",
        },
        shippingRates: {
            root: "/cc/shipping-rates",
        },
        taxRegistrations: {
            root: "/cc/tax-registrations",
        },
        taxCertificates: {
            root: "/cc/tax-certificates",
        },
        installerCompliance: {
            root: "/cc/installer-compliance",
        },
        outboundCoi: {
            root: "/cc/coi",
        },
        permissionFlags: {
            root: "/cc/permission-flags",
        },
        internalApiKeys: {
            root: "/cc/internal-api-keys",
        },
        accountProfileSettings: {
            root: "/cc/account-profile-settings",
        },
        unitsSold: {
            root: "/cc/units-sold",
        },
        freeItems: {
            root: "/cc/free-items",
        },
    },
    opportunities: {
        root: "/opportunities",
        create: "/opportunities/create",
        details: "/opportunities/:id",
    },
    myWorkspace: {
        prefix: "/my-workspace",
        root: "/my-workspace/board",
        leads: {
            root: "/my-workspace/my-leads",
            create: "/my-workspace/my-leads/create",
            details: "/my-workspace/my-leads/:id",
            convert: "/my-workspace/my-leads/:id/convert",
            upload: "/my-workspace/my-leads/upload",
        },
        opportunities: {
            root: "/my-workspace/my-opportunities",
            create: "/my-workspace/my-opportunities/create",
            details: "/my-workspace/my-opportunities/:id",
        },
        quotes: {
            root: "/my-workspace/my-quotes",
            details: "/my-workspace/my-quotes/:id",
            checkout: "/my-workspace/my-quotes/:id/checkout",
        },
        orders: {
            root: "/my-workspace/my-orders",
            details: "/my-workspace/my-orders/:id",
        },
        proposals: {
            root: "/my-workspace/my-proposals",
        },
    },
    api: {
        apiKeys: {
            root: "/ui-api/keys",
            create: "/ui-api/keys/create",
            details: "/ui-api/keys/:id",
        },
        walletCredentials: {
            root: "/ui-wallet-credentials",
            create: "/ui-wallet-credentials/create",
            details: "/ui-wallet-credentials/:id",
        },
        walletTemplates: {
            root: "/ui-wallet-templates",
            create: "/ui-wallet-templates/create",
            details: "/ui-wallet-templates/:id",
        },
        walletCards: {
            root: "/ui-wallet-cards",
            create: "/ui-wallet-cards/create",
            details: "/ui-wallet-cards/:id",
        },
        paymentMethods: {
            root: "/ui-payment-methods",
            details: "/ui-payment-methods/:id",
        },
        logs: {
            root: "/ui-logs",
            details: "/ui-logs/:id",
        },
        documentation: {
            root: "/ui-documentation",
        },
        settings: {
            // API Partner self-service settings page (currently: wallet
            // webhook URL + secret). Routed under /ui-* to keep it
            // grouped with the other API portal pages.
            root: "/ui-settings",
        },
    },
    documents: {
        root: "/documents",
    },
    installer: {
        join: "/installer/join",
        project: "/installer/project/:uuid",
    },
    ec: {
        login: "/ec/login",
        projects: "/ec/projects",
        projectDetails: "/ec/projects/:id",
        orders: "/ec/orders",
        orderDetails: "/ec/orders/:id",
        orderPay: "/ec/orders/:id/pay",
        paymentMethods: "/ec/settings/payment-methods",
        documents: "/ec/documents",
    },
};
